module.exports = __webpack_public_path__ + "static/1308972968-wide.29854e30.jpg";